export default __webpack_public_path__ + "maps-overview-quickstart-result-1200-25b6a37b8e6ae6d22188e6323a23d1fc.png";